import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import { reducer as viewerPageReducer } from 'modules/viewerPage';

import quoteViewerPageReducer from './data/reducer';
import routes from './data/routes';
import qpvSaga from './data/sagas';
import modalsReducer from './modals/data/reducer';
import modalsSaga from './modals/data/sagas';

const reducer = combineReducers({
  app: combineReducers({
    viewerPageReducer: viewerPageReducer,
    quoteViewerPageReducer: quoteViewerPageReducer,
    modalsReducer,
  }),
});

const saga = function* () {
  yield all([qpvSaga(), modalsSaga()]);
};

export { reducer, saga, routes };
